import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANG, LanguageService } from '../services/language.service';

export const langGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const translateService = inject(TranslateService);
  const languageService = inject(LanguageService);

  const lang = route.paramMap.get('lang');

  if (!lang || !languageService.isSupported(lang)) {
    const rest = state.url.replace(/^\/[^/]*/, '');
    router.navigateByUrl(`/${ DEFAULT_LANG }${ rest }`);
    return false;
  }

  languageService.setLang(lang);
  translateService.use(lang);

  return true;
};
